/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Button_TextInputs */

const en_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel`)
};

const id_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

const ms_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal`)
};

const ca_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel·la`)
};

const cs_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit `)
};

const da_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuller`)
};

const de_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abbrechen`)
};

const et_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tühista`)
};

const es_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const fr_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuler`)
};

const hr_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otkaži`)
};

const it_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla`)
};

const lv_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atcelt`)
};

const lt_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atšaukti`)
};

const hu_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mégse`)
};

const nl_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annuleer`)
};

const nb_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avslutt`)
};

const pl_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anuluj`)
};

const pt_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancelar`)
};

const ro_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anulare`)
};

const sk_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit`)
};

const sl_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prekliči`)
};

const fi_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peruuta`)
};

const sv_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avbryt`)
};

const vi_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hủy`)
};

const tr_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İptal`)
};

const el_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ακύρωση`)
};

const bg_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмяна`)
};

const ru_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена`)
};

const sr_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Откажи`)
};

const uk_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скасувати`)
};

const ka_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`გაუქმება`)
};

const hi_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`रद्द करना`)
};

const th_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยกเลิก`)
};

const ko_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`취소`)
};

const zh_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const zh_tw_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`取消`)
};

const ja_cancel_button_text = /** @type {(inputs: Cancel_Button_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`キャンセル`)
};

/**
* | output |
* | --- |
* | "Cancel" |
*
* @param {Cancel_Button_TextInputs} inputs
* @param {{ locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }} options
* @returns {LocalizedString}
*/
export const cancel_button_text = /** @type {((inputs?: Cancel_Button_TextInputs, options?: { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Button_TextInputs, { locale?: "en" | "id" | "ms" | "ca" | "cs" | "da" | "de" | "et" | "es" | "fr" | "hr" | "it" | "lv" | "lt" | "hu" | "nl" | "nb" | "pl" | "pt" | "ro" | "sk" | "sl" | "fi" | "sv" | "vi" | "tr" | "el" | "bg" | "ru" | "sr" | "uk" | "ka" | "hi" | "th" | "ko" | "zh" | "zh-tw" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cancel_button_text(inputs)
	if (locale === "ms") return ms_cancel_button_text(inputs)
	if (locale === "ca") return ca_cancel_button_text(inputs)
	if (locale === "cs") return cs_cancel_button_text(inputs)
	if (locale === "da") return da_cancel_button_text(inputs)
	if (locale === "de") return de_cancel_button_text(inputs)
	if (locale === "et") return et_cancel_button_text(inputs)
	if (locale === "es") return es_cancel_button_text(inputs)
	if (locale === "fr") return fr_cancel_button_text(inputs)
	if (locale === "hr") return hr_cancel_button_text(inputs)
	if (locale === "it") return it_cancel_button_text(inputs)
	if (locale === "lv") return lv_cancel_button_text(inputs)
	if (locale === "lt") return lt_cancel_button_text(inputs)
	if (locale === "hu") return hu_cancel_button_text(inputs)
	if (locale === "nl") return nl_cancel_button_text(inputs)
	if (locale === "nb") return nb_cancel_button_text(inputs)
	if (locale === "pl") return pl_cancel_button_text(inputs)
	if (locale === "pt") return pt_cancel_button_text(inputs)
	if (locale === "ro") return ro_cancel_button_text(inputs)
	if (locale === "sk") return sk_cancel_button_text(inputs)
	if (locale === "sl") return sl_cancel_button_text(inputs)
	if (locale === "fi") return fi_cancel_button_text(inputs)
	if (locale === "sv") return sv_cancel_button_text(inputs)
	if (locale === "vi") return vi_cancel_button_text(inputs)
	if (locale === "tr") return tr_cancel_button_text(inputs)
	if (locale === "el") return el_cancel_button_text(inputs)
	if (locale === "bg") return bg_cancel_button_text(inputs)
	if (locale === "ru") return ru_cancel_button_text(inputs)
	if (locale === "sr") return sr_cancel_button_text(inputs)
	if (locale === "uk") return uk_cancel_button_text(inputs)
	if (locale === "ka") return ka_cancel_button_text(inputs)
	if (locale === "hi") return hi_cancel_button_text(inputs)
	if (locale === "th") return th_cancel_button_text(inputs)
	if (locale === "ko") return ko_cancel_button_text(inputs)
	if (locale === "zh") return zh_cancel_button_text(inputs)
	if (locale === "zh-tw") return zh_tw_cancel_button_text(inputs)
	if (locale === "ja") return ja_cancel_button_text(inputs)
	return en_cancel_button_text(inputs)
});